export const isValidAnswer = (answer) => {
	if (Array.isArray(answer) || typeof answer === "string") return answer && answer.length > 0;
	return !!answer;
};
